import EllipsisOutlined from '@ant-design/icons/EllipsisOutlined'
import {Dropdown} from 'antd'
import React, {useEffect} from 'react'
import {useToggle} from 'react-use'

export const DropDownMenu = ({
                                 placement = 'bottomRight',
                                 component = <EllipsisOutlined/>,
                                 container,
                                 menu,
                                 open,
                                 ...props
                             }) => {
    const [isToggle, toggle] = useToggle()

    useEffect(() => {
        toggle(!!open)
    }, [open])

    return (
        <Dropdown
            {...props}
            open={isToggle}
            trigger={['click']}
            placement={placement}
            onOpenChange={(open) => toggle(open)}
            menu={menu}
            getPopupContainer={() => document.getElementById(container)}>
            {component}
        </Dropdown>
    )
}

export default DropDownMenu
